export default {
  methods: {
    getTipoContrato(contrato) {
      if (this.contrato.obras.length < 1) return '';
      const tipoContrato = contrato.obras[0].obra.tipo.descripcion;
      return tipoContrato;
    },
    async generarPdfDatosGenerales() {
      const nombreTemplate = 'templateInformeDatosGenerales';
      const datosContrato = this.formatoObjeto(this.getContrato);
      const tipoContrato = this.getTipoContrato(this.getContrato);
      const contratosRelacionadosOrden = this.getContrato.contratosRelacionados
        .map((c) => c.contratoRelacionado)
        .sort((a, b) => a.orden - b.orden)
        .map((c) => (this.formatoObjeto({
          ...c,
          ...this.getContrato.contratosRelacionados
            .find(({ idContratoRelacionado }) => idContratoRelacionado === c.id),
        })));

      const datosFecha = this.formatoObjeto({
        fechaDel: this.fechaDelInforme,
        fechaAl: this.fechaAlInforme,
      });
      const logo = this.getCliente?.logo || '';

      await this.mixGenerarPdf({
        configuracion: {
          path: 'wepp/wep',
          PUPPETEER_CONFIGURACION: {
            landscape: false,
            format: 'A3',
            footerTemplate: '',
          },
          nombreTemplate,
        },
        data: {
          contrato: datosContrato,
          contratosRelacionadosOrden,
          tipoContrato,
          fecha: datosFecha,
          numeroInforme: this.numeroInforme,
          logo,
          footer: '',
        },
      }, `${this.contrato.numero}_DatosGenerales_${this.fechaDelInforme}_${this.fechaAlInforme}`);
      this.documentoSeleccionado = null;
    },
  },
};
